import { IdValue } from '../../../shared/models/id-value.model';

export const tridSummariesOfTransactionSection: IdValue[] = [
  new IdValue(0, 'DueFromBor', 'Due from Borrower'),
  new IdValue(1, 'DueToSeller', 'Due to Seller'),
  new IdValue(2, 'PaidByOrOnBehalfOfBor', 'Paid by or on behalf of Borrower'),
  new IdValue(3, 'DueFromSeller', 'Due from Seller'),
];

export const landValueTypes: IdValue[] = [
  new IdValue(0, 'OmitLandValue', 'Omit Land Value'),
  new IdValue(1, 'AppraisedValueOfLot', 'Appraised Value of Lot'),
  new IdValue(2, 'OriginalCostOfLot', 'Original Cost of Lot'),
];

export enum PaidByOtherType {
  seller = 0,
  lender = 1,
  thirdParty = 2,
  builder = 3,
  employer = 4,
  federalAgency = 5,
  localAgency = 6,
  nonParentRelative = 7,
  parent = 8,
  realEstateAgent = 9,
  stateAgency = 10,
  unrelatedFriend = 11,
}

export const paidByOtherTypeOptions: IdValue[] = [
  new IdValue(PaidByOtherType.seller, 'Seller', 'Seller'),
  new IdValue(PaidByOtherType.lender, 'Lender', 'Lender'),
  new IdValue(PaidByOtherType.thirdParty, 'Third Party', 'Third Party'),
  new IdValue(PaidByOtherType.builder, 'Building (Other than Seller)', 'Building (Other than Seller)'),
  new IdValue(PaidByOtherType.employer, 'Employer', 'Employer'),
  new IdValue(PaidByOtherType.federalAgency, 'Federal Agency', 'Federal Agency'),
  new IdValue(PaidByOtherType.localAgency, 'Local Agency', 'Local Agency'),
  new IdValue(PaidByOtherType.nonParentRelative, 'Non Parent Relative', 'Non Parent Relative'),
  new IdValue(PaidByOtherType.parent, 'Parent', 'Parent'),
  new IdValue(PaidByOtherType.realEstateAgent, 'Real Estate Agent', 'Real Estate Agent'),
  new IdValue(PaidByOtherType.stateAgency, 'State Agency', 'State Agency'),
  new IdValue(PaidByOtherType.unrelatedFriend, 'Unrelated Friend', 'Unrelated Friend'),
];
